import { Component, Input, OnInit } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, publishReplay, refCount } from 'rxjs/operators';

import { PinnedItem, SideNavigationItem, SideNavigationLink } from '../atlas_sdk/api';
import { PinsService } from '../pins.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { BusinessNavDataService } from '../data.service';

@Component({
  selector: 'atlas-bc-pinned-items',
  templateUrl: './bc-pinned-items.component.html',
  styleUrls: ['./bc-pinned-items.component.scss']
})
export class BcPinnedItemsComponent implements OnInit {
  @Input() sideNavigationItem: Observable<SideNavigationItem[]>;

  pinnedItems$: Observable<SideNavigationLink[]>;
  disablePinning$: Observable<boolean>;
  ooProducts: string[] = ['product-RM' ,'product-SM' ,'product-MS', 'product-MP-94072e44d5364872b672d7ab4fc7a7e8', 'product-MP-c4974d390a044c28aec31e421aa662b2', 'product-MP-ee4ea04e553a4b1780caf7aad7be07cd'];
  constructor(private pinService: PinsService, private dataService: BusinessNavDataService) {
  }
  ngOnInit(): void {
    const pinIds$ = this.pinService.pins$.pipe(
      filter((pins: PinnedItem[]) => pins !== undefined && pins !== null),
      map((pins: PinnedItem[]) => pins.map(p => p.navigationId)),
      publishReplay(1),
      refCount()
    );

    const items$ = this.sideNavigationItem.pipe(
      filter((item: SideNavigationItem[]) => !!item),
      publishReplay(1),
      refCount()
    );
    this.pinnedItems$ = combineLatest(pinIds$, items$).pipe(
      map(([pinIds, navItems]: [string[], SideNavigationItem[]]) => {
        let foundItems: SideNavigationLink[] = [];
        for (const item of navItems) {
          foundItems = this.searchSidenavigationItem(item, pinIds, foundItems);
        }
        return this.orderPinnedItems(foundItems, pinIds);
      }),
      publishReplay(1),
      refCount()
    );

    // Disable pinning if there is not a user ID
    this.disablePinning$ = this.dataService.userId$.pipe(map((userID: string) => !userID));
  }

  onMouseDown(event: Event): void {
    event.preventDefault();
  }

  onDrop(event: CdkDragDrop<SideNavigationLink[]>): void {
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    this.pinService.setPins(
      event.container.data.map(
        (data: SideNavigationLink) => new PinnedItem({ navigationId: data.navigationId })
      )
    );
  }

  private searchSidenavigationItem(navItem: SideNavigationItem, pinIds: string[], foundLinks: SideNavigationLink[]): SideNavigationLink[] {
    if (!pinIds || pinIds.length === 0) {
      return foundLinks;
    }

    if (!!navItem.sideNavigationLink) {
      if (pinIds.indexOf(navItem.sideNavigationLink.navigationId) > -1) {
        foundLinks.push(navItem.sideNavigationLink);
        return foundLinks;
      }
    } else if (!!navItem.sideNavigationContainer && !!navItem.sideNavigationContainer.sideNavigationItems) {
      for (const item of navItem.sideNavigationContainer.sideNavigationItems) {
        foundLinks = this.searchSidenavigationItem(item, pinIds, foundLinks);
      }
      return foundLinks;
    } else if (!!navItem.sideNavigationSection && !!navItem.sideNavigationSection.sideNavigationItems) {
      for (const item of navItem.sideNavigationSection.sideNavigationItems) {
        foundLinks = this.searchSidenavigationItem(item, pinIds, foundLinks);
      }
      return foundLinks;
    }

    return foundLinks;
  }

  private orderPinnedItems(pinnedItems: SideNavigationLink[], pinIds: string[]): SideNavigationLink[] {
    if (!pinIds) {
      return pinnedItems;
    }
    const orderedItems: SideNavigationLink[] = [];
    for (const pinId of pinIds) {
      const item = pinnedItems.find((pinnedItem: SideNavigationLink) => pinnedItem.navigationId === pinId);
      if (!!item) {
        orderedItems.push(item);
      }
    }
    if (orderedItems && orderedItems.length > 0) {
      for (let i = 0; i < orderedItems.length; i++) {
        if (this.ooProducts.includes(orderedItems[i].navigationId)) {
          orderedItems[i].ooProduct = true;
        }
      }
    }
    return orderedItems;
  }
}
